import { useCallback, useState } from "react";

const useDialog = () => {
    const [dialog, setDialog] = useState("");

    const openDialog = useCallback((key) => {
        setDialog(key);
    }, []);

    const closeDialog = useCallback(() => {
        setDialog("");
    }, []);

    return {
        dialog,
        openDialog,
        closeDialog,
    };
};

export default useDialog;
